module.exports = ['$http', '$q', function($http, $q) {

	const authoringTypeURL = '/api/authoring/v1/types';
	const authoringCountURL = '/api/authoring/v1/content/count';
	
	/**
	* Returns a promise to the JSON for the current content types
	* @return {Promise}
	*/
	function getCurrentContentTypes() {
		return $http.get(authoringTypeURL + '?classification=content-type&fields=id,name,description,kind&limit=500').then(
			(res) => res.data,
			(res) => $q.reject(res.status + ' :: ' + res.data)
		);
	}

	/**
	* Returns a promise to the JSON for the current content item usage
	* @return {Promise}
	*/
	function getCurrentContentItemUsage() {
		return $http.get(authoringCountURL).then(
			(res) => res.data.count,
			(res) => $q.reject(res.status + ' :: ' + res.statusText)
		);
	}

	// return public API for the REST factory
    return {
    	getCurrentContentTypes: getCurrentContentTypes,
    	getCurrentContentItemUsage: getCurrentContentItemUsage
    };
}];



// WEBPACK FOOTER //
// ./app/common/services/content-service.factory.js